<div mat-dialog-content>
  <p>Sind Sie sicher?</p>  
</div>
<div mat-dialog-actions>  
  <button mat-button [mat-dialog-close]="false">Abbrechen</button>  
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/dialogs/confirm/confirm.component.html